// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import "jquery/dist/jquery";
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

import AOS from "aos/dist/aos";
import "owl.carousel2/dist/owl.carousel";

import "./components/sly";
import "jquery.easing/jquery.easing";


// Initialise our components on jQuery.ready…
jQuery(function ($) {
	
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();

	initServicesSlider();
	AOS.init();

	function initServicesSlider() {
		console.log('initServicesSlider');
		var checkWidth = $(window).width();
		var $servicesSlider = $("#centered");
		var $wrap  = $servicesSlider.parent();

		if (checkWidth <= 768) {
			console.log('smaller devices');
			if($servicesSlider.hasClass('frame')){
				$servicesSlider.sly(false);
			}

			$(".frame .services-card").each(function(){
				$(this).attr('data-aos-delay', 50);
				
				$(this).find('.hover-overlay').css('background-image', 'url("'+$(this).attr('data-hover-tablet')+'")');
			});

		} else {
			console.log('desktop');
			var multiplier = 1;
			$(".frame .services-card").each(function(){
				$(this).attr('data-aos-delay', eval(multiplier*100));
				multiplier 		= eval(multiplier+1);

				$(this).find('.hover-overlay').css('background-image', 'url("'+$(this).attr('data-hover-desktop')+'")');
			});
			
			// Call Sly on frame
			$servicesSlider.sly({
				horizontal: 1,
				itemNav: 'centered',
				dragSource: null,
				smart: 1,
				activateOn: 'click',
				mouseDragging: false,
				touchDragging: true,
				releaseSwing: false,
				// startAt: 4,
				scrollBar: $wrap.find('.scrollbar'),
				scrollBy: 0,
				speed: 300,
				elasticBounds: 1,
				easing: 'easeOutExpo',
				dragHandle: 1,
				scrollSource: null,
				// dynamicHandle: 1,
				clickBar: false,
			
				// Buttons
				prev: $wrap.find('.prev'),
				next: $wrap.find('.next')
			});
		}
	}

	var initialHeader = $("#header-wrapper").outerHeight();

    $(".inline-block-has-children > a").click(function(e) {
		// e.stopImmediatePropagation();
		var $this = this;
		var screenWidth = $(document).width();

		$($this).closest('.inline-block-has-children').siblings().each(function(){
			$(this).removeClass('active');

			$(this).each(function() {
				$(this).find('.sub-menu').slideUp();
			});
		});

		$($this).closest('.inline-block-has-children').toggleClass('active');
		
		if(screenWidth < 1024) {
			console.log('fires');
			$($this).closest('.inline-block-has-children').find('.sub-menu').slideToggle();
		}

		return false;
	});
	
	$("html").click(function(e) {
		if( !$(e.target).closest('li').hasClass('inline-block-has-children') && !$(e.target).closest('.navbar-wrapper').hasClass('active') ) {
			$('.inline-block-has-children').removeClass('active');
		}
    });
	
	$(".sidebar-toggle, .overlay").click(function(e) {
		e.preventDefault();

		$(".sidebar-wrapper").removeClass('active'); // open sidebar
		
		setTimeout(() => {
			$(".navbar-wrapper").toggleClass('active');
			$("body").toggleClass('sidebar-toggled');
			$("html").toggleClass('overflow-hidden');
		}, 100);
	});
	
	var anchorLink = $(window.location.hash);
    // test to see if the link is a anchor link, if not the length will have no value, this is done to avoid js errors on non anchor links
	if ( anchorLink.length ) {
		setTimeout(function(){
			console.log('anchor link');
			// set an element as the fixed entity, header in this case and get its height
			// var offsetSize = jQuery("header").innerHeight();
			var offsetSize = 85;
			// fire the animation from the top of the page to the anchor link offsetting by the fixed elements height, the number is the speed of the animation
			jQuery("html, body").animate({scrollTop: anchorLink.offset().top - offsetSize }, 500);
		}, 1000)
	}
    
	$(window).resize(function () {		
		// var screenWidth = $(document).width();
		initServicesSlider();
		var checkWidth = $(window).width();

		$(".inline-block-has-children").each(function(i, elem){
			$(elem).removeClass('active');
			$(elem).find('.sub-menu').hide(200, function() {
				$(this).attr('style', '');
			});
		});

		if(checkWidth < 1024) {
			if(!$(".navbar-wrapper").hasClass('active')) {
				$(".sidebar-wrapper").addClass('active'); // close sidebar / ready the sidebar to be trigger
			}
		} else {
			$("html").removeClass('overflow-hidden');
			$(".sidebar-wrapper").removeClass('active'); // open sidebar
			$(".navbar-wrapper").removeClass('active');
		}
	});
	
	$(window).scroll(function () {
		var screenWidth = $(document).width();
		
		if ($(this).scrollTop() >= initialHeader) {
			$(".sticky-header").addClass('sticked');

			if(screenWidth >= 1024) {
				initialHeader = $(".navbar-wrapper").outerHeight();
			}
			
			$("#content-wrapper").css('padding-top', (initialHeader));

		} else {
			$(".sticky-header").removeClass('sticked');
			$("#content-wrapper").css('padding-top', 0);
			initialHeader = $("#header-wrapper").outerHeight();
		}
	});

});